import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/noData_empty.svg'


const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = {
  key: 1,
  class: "absolute w-full bottom-0"
}
const _hoisted_3 = {
  key: 2,
  class: "w-full h-full"
}
const _hoisted_4 = { class: "w-full h-full bg-white justify-center items-center flex flex-col mx-auto text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-32 mt-8 mx-auto",
  alt: "noData_empty"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-gray-lp-300 py-2" }, " Belum ada data Commodity Surcharge yang dapat ditampilkan ", -1)
const _hoisted_7 = { class: "absolute w-full bottom-0" }
const _hoisted_8 = { class: "border-t border-gray-lp-200 border-b overflow-y-auto h-screen pb-52" }
const _hoisted_9 = { class: "absolute w-full bottom-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_TableLazyLoad = _resolveComponent("TableLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_TableV1 = _resolveComponent("TableV1")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      currentRoutes: _ctx.getCurrentRoute,
      isSearchable: true,
      isSelectStatus: true,
      isButtonAction: _ctx.isCreateAble,
      placeholder: "Cari nama komoditas",
      searchValue: _ctx.search,
      searchAction: _ctx.onSearch,
      clearSearch: _ctx.clearSearch,
      statusData: _ctx.statusData,
      onOpenStatusSelect: _ctx.onOpenStatusSelect,
      onCloseStatusSelect: _ctx.onCloseStatusSelect,
      onSelectStatus: _ctx.onSelectStatus,
      valueStatus: _ctx.statusName,
      statusSelect: _ctx.statusSelect,
      buttonText: `Buat Tarif Komoditas`,
      buttonAction: _ctx.toPageAdd
    }, null, 8, ["currentRoutes", "isButtonAction", "searchValue", "searchAction", "clearSearch", "statusData", "onOpenStatusSelect", "onCloseStatusSelect", "onSelectStatus", "valueStatus", "statusSelect", "buttonAction"]),
    _withDirectives(_createVNode(_component_TableLazyLoad, { columns: _ctx.columns }, null, 8, ["columns"]), [
      [_vShow, _ctx.isLoading]
    ]),
    (
        ((_ctx.listData.length === 0 && (_ctx.search || _ctx.status || _ctx.page !== 1)) ||
          _ctx.isError) &&
          !_ctx.isLoading
      )
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.isError ? _ctx.errorCause : 'notfound',
          onTryAgain: _ctx.isError && _ctx.onReload
        }, null, 8, ["errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    (
        ((_ctx.listData.length === 0 && (_ctx.search || _ctx.status || _ctx.page !== 1)) ||
          _ctx.isError) &&
          !_ctx.isLoading
      )
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Pagination, {
            onNext: _ctx.nextPage,
            onPrevious: _ctx.prevPage,
            page: _ctx.page,
            toPage: _ctx.toPage
          }, null, 8, ["onNext", "onPrevious", "page", "toPage"])
        ], 512)), [
          [_vShow, !_ctx.isError]
        ])
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _withDirectives(_createVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Pagination, {
                onNext: _ctx.nextPage,
                onPrevious: _ctx.prevPage,
                page: _ctx.page,
                toPage: _ctx.toPage
              }, null, 8, ["onNext", "onPrevious", "page", "toPage"])
            ])
          ], 512), [
            [_vShow, 
          _ctx.listData.length === 0 &&
            !_ctx.isLoading &&
            !_ctx.search &&
            !_ctx.status &&
            _ctx.page === 1
        ]
          ]),
          _withDirectives(_createVNode("div", _hoisted_8, [
            _createVNode(_component_TableV1, {
              columns: _ctx.columns,
              data: _ctx.listData,
              class: "my-2",
              onClick: _ctx.onClickRow,
              isDetailAble: _ctx.isDetailAble
            }, null, 8, ["columns", "data", "onClick", "isDetailAble"])
          ], 512), [
            [_vShow, _ctx.listData.length !== 0 && !_ctx.isLoading]
          ]),
          _withDirectives(_createVNode("div", _hoisted_9, [
            _createVNode(_component_Pagination, {
              onNext: _ctx.nextPage,
              onPrevious: _ctx.prevPage,
              page: _ctx.page,
              isButtonNext: _ctx.listData.length >= _ctx.limit,
              totalData: _ctx.listData.length,
              toPage: _ctx.toPage
            }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "totalData", "toPage"])
          ], 512), [
            [_vShow, _ctx.listData.length !== 0 && !_ctx.isLoading]
          ])
        ]))
  ]))
}